<ifr-page-title pageTitle="'LEFT_PANEL_CREDENTIAL_ADMINISTRATION' | translate "/>
<credential-administration-container
  will-leave="ctrl.willLeave"
  on-will-leave-result="onWillLeaveResult"
/>
